import { render, staticRenderFns } from "./FormStatusBar.vue?vue&type=template&id=b084dc12&"
import script from "./FormStatusBar.vue?vue&type=script&lang=js&"
export * from "./FormStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./FormStatusBar.vue?vue&type=style&index=0&id=b084dc12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports